import { h } from 'vue';
import {
  CAMPAIGN_CHANNELS,
  CAMPAIGN_CHANNEL_DOT_CLASSES,
  CAMPAIGN_CHANNEL_FILTERS,
} from 'dashboard/components-next/Campaigns/helpers/campaignFilters';

// Sidebar label keys are per-channel, not the filter values themselves.
const CHANNEL_LABEL_KEYS = {
  [CAMPAIGN_CHANNEL_FILTERS.LIVE_CHAT]: 'SIDEBAR.LIVE_CHAT',
  [CAMPAIGN_CHANNEL_FILTERS.SMS]: 'SIDEBAR.SMS',
  [CAMPAIGN_CHANNEL_FILTERS.WHATSAPP]: 'SIDEBAR.WHATSAPP',
};

const channelDot = channel =>
  h('span', {
    class: `size-[8px] rounded-full ${CAMPAIGN_CHANNEL_DOT_CLASSES[channel]}`,
  });

/**
 * Campaigns as a group inside the Customers panel: All plus one entry per
 * channel. The channel entries are filter presets over the same unified
 * dashboard — `campaigns_channel_index` renders `AllCampaignsPage` scoped to
 * its `:channel` segment — and carry a client-side count of how many
 * campaigns they stand for.
 */
export default ({ t, accountScopedRoute, campaignCounts }) => {
  return {
    name: 'Campaigns',
    label: t('SIDEBAR.CAMPAIGNS'),
    icon: 'i-ph-megaphone',
    children: [
      {
        name: 'All Campaigns',
        label: t('SIDEBAR.ALL_CAMPAIGNS'),
        to: accountScopedRoute('campaigns_index'),
        activeOn: ['campaigns_index', 'campaigns_builder'],
        badgeCount: campaignCounts[CAMPAIGN_CHANNEL_FILTERS.ALL],
      },
      ...CAMPAIGN_CHANNELS.map(channel => ({
        name: `Campaigns ${channel}`,
        label: t(CHANNEL_LABEL_KEYS[channel]),
        icon: channelDot(channel),
        to: accountScopedRoute('campaigns_channel_index', { channel }),
        activeOn: ['campaigns_channel_index'],
        badgeCount: campaignCounts[channel],
      })),
    ],
  };
};
